import {Card, Flex} from 'antd';
const AppsPage = (props) => {
    const apps = [
        {
            key: "tzolkin-lite",
            title: "Цолькин Лайт",
            cover: "/img/screenshots/tz-lite0.png",
            apk: "/apps/tzolkin_2019.04.12_v6_beta.apk",
            description: "Приложение для старых телефонов, работает почти любых смартфонах",
            actions: [
                (<a key="web" href="https://old.daysign.ru/">Веб версия (без установки)</a>)
            ]
        },
        {
            key: "daysign",
            title: "DaySign",
            cover: "/img/screenshots/ds0.jpg",
            apk: "/apps/DaySign_v1.0.2.apk",
            description: "Актуальное приложение со всеми последними фичами",
            actions: [
                (<a key="web" href="https://app.daysign.ru/">Веб версия (без установки)</a>)
            ]

        },
        {
            key: "tzolkin",
            title: "Цолькин",
            cover: "/img/screenshots/tz1.png",
            apk: "/apps/tzolkin_2019.04.12_v6_beta.apk",
            description: "Переведённое на русский язык приложение TzolkinExplorer и дополненое расчётом фантомов"
        }
    ];
    const appscontent = apps.map(app => (<Card
    hoverable
    title={app.title}
    extra={(<a href={app.apk}>Скачать</a>)}
    style={{width: 240}}
    actions={app.actions}
    cover={(<img src={app.cover}/>)}>
        <Card.Meta description={app.description}></Card.Meta>
    </Card>));
    return (<Flex style={{margin: "1em"}} gap="1em" justify='center' align='top'>{appscontent}
    </Flex>);
}
export default AppsPage;